const ACCESS_KEY = 'rsvs.aff_access';
const REFRESH_KEY = 'rsvs.aff_refresh';
const USER_KEY = 'rsvs.aff_user';

export interface AffiliateUser {
  id: string;
  code: string;
  name: string;
  email: string;
  mpConnected: boolean;
  status: 'active' | 'pending_kyc' | 'suspended' | 'banned';
}

export interface AffiliateAuthResult {
  accessToken: string;
  refreshToken: string;
  affiliate: AffiliateUser;
}

export function getAffiliateToken(): string | null {
  return localStorage.getItem(ACCESS_KEY);
}

export function getAffiliateUser(): AffiliateUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AffiliateUser;
  } catch {
    return null;
  }
}

export function isAffiliateAuthenticated(): boolean {
  return !!getAffiliateToken();
}

export function setAffiliateAuth(result: AffiliateAuthResult): void {
  localStorage.setItem(ACCESS_KEY, result.accessToken);
  localStorage.setItem(REFRESH_KEY, result.refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(result.affiliate));
}

export function setAffiliateUser(user: AffiliateUser): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearAffiliateAuth(): void {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
}
